import { AUTH_STORAGE_KEYS } from "../constants/storageKeys";
import { clearAuthStorage } from "./tokenUtils";

let isHandlingSessionExpiry = false;

/**
 * Clears auth data and redirects to login.
 * Guarded so multiple simultaneous 401s only trigger one redirect.
 */
export function handleSessionExpired(): void {
  if (isHandlingSessionExpiry) {
    return;
  }

  isHandlingSessionExpiry = true;
  clearAuthStorage();

  const isLoginPage = window.location.pathname === "/login";
  if (!isLoginPage) {
    window.location.href = "/login";
  }
}

/**
 * Returns true when localStorage no longer has a token but the app
 * still holds an in-memory session (e.g. another tab logged out).
 */
export function isSessionStale(inMemoryToken: string | null): boolean {
  if (!inMemoryToken) {
    return false;
  }

  return !localStorage.getItem(AUTH_STORAGE_KEYS.TOKEN);
}

/**
 * Syncs in-memory auth state when another tab clears the session.
 */
export function forceLogoutFromOtherTab(): void {
  handleSessionExpired();
}
